import {Radio} from 'antd-mobile'

export default class RadioGroup extends React.Component {
	constructor(props) {
		super(props);
    }
	componentDidMount(){
		const {value,onChange} = this.props;
		!value && onChange('1');
	}
	render(){
		const {value,onChange,disabled,limit} = this.props;
		const valueNew = !!value ? value : '1';
		return <div>
			<Radio value='0' checked={valueNew == '0'} disabled={disabled || limit} onChange={(e)=>{onChange(e.target.value)}} >临时（20天）</Radio>
			<Radio value='1' checked={valueNew == '1'} disabled={disabled} onChange={(e)=>{onChange(e.target.value)}} >永久</Radio>
		</div>
	}
}


// WEBPACK FOOTER //
// ./project/components/app/appApply/RadioGroup.js